import React from 'react';
import Breadcrumbs from '@homeaway/react-breadcrumbs';
import PropTypes from 'prop-types';
import './Category.less';

export const linkPropTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export const categoryPropTypes = {
    name: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(...linkPropTypes)).isRequired,
    isBreadcrumbs: PropTypes.bool
};

function Category(props) {
    const {name, links, isBreadcrumbs} = props;

    return (
        <div className="Category">
            {name && <h3 className="Category__item Category__title">{name}</h3>}
            <div className="Category__item Category__links">
                {isBreadcrumbs ? (
                    <Breadcrumbs crumbs={links.map((link) => ({url: link.url, name: link.text}))} isLastCrumbLinked />
                ) : (
                    <ul className="list-inline Category__list">
                        {links.map((link, i) => (
                            <li key={`${link.text}-${i}`} className="Category__list-item">
                                <a href={link.url} title={link.text} className="Category__link">
                                    <span>{link.text}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

Category.propTypes = categoryPropTypes;
Category.defaultProps = {
    name: '',
    links: [],
    isBreadcrumbs: false
};

export default Category;
